import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  SettingsSection,
  Switch,
  TextField,
  settingsStore,
  useKeyboardShortcuts,
} from "@jkast90/kast-common/ui";
import { AUTO_DISMISS_KEY, useBanner } from "../banner";
import { getDeploymentConfig } from "../deploymentConfig";
import { KitAppSettings } from "../accountKit";

const API_URL_KEY = "dashboard_api_url";

const isLocalhost = () =>
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

function BannerSection() {
  const [autoDismiss, setAutoDismiss] = useState(
    () => localStorage.getItem(AUTO_DISMISS_KEY) !== "false",
  );
  return (
    <SettingsSection title="Messages">
      <Switch
        size="sm"
        label="Auto-dismiss banner messages"
        description="Off, banners stay until you close them"
        checked={autoDismiss}
        onChange={(on) => {
          setAutoDismiss(on);
          localStorage.setItem(AUTO_DISMISS_KEY, String(on));
        }}
      />
    </SettingsSection>
  );
}

/** Local development only: where this device's dashboard finds its API. */
function ApiUrlSection() {
  const { showBanner } = useBanner();
  const [apiUrl, setApiUrl] = useState(
    () => localStorage.getItem(API_URL_KEY) || "",
  );
  return (
    <SettingsSection title="Dashboard API">
      <TextField
        label="Dashboard API URL"
        value={apiUrl}
        onChange={(e) => setApiUrl(e.target.value)}
        placeholder="https://..."
        hint={`Auto-detected: ${getDeploymentConfig().apiUrl}`}
      />
      <Button
        size="sm"
        onClick={() => {
          if (apiUrl) localStorage.setItem(API_URL_KEY, apiUrl);
          else localStorage.removeItem(API_URL_KEY);
          showBanner("API URL saved");
        }}
      >
        Save API URL
      </Button>
    </SettingsSection>
  );
}

/**
 * The settings dialog, mounted once in App: the account page's gear opens it,
 * and so does Shift+S.
 */
export default function AppSettings() {
  useKeyboardShortcuts({ "shift+s": () => settingsStore.open() });

  return (
    <KitAppSettings>
      <SettingsSection title="Families">
        <div className="kui-settings-links">
          <Link
            to="/families"
            className="kui-settings-link"
            onClick={() => settingsStore.close()}
          >
            Manage your families
          </Link>
        </div>
      </SettingsSection>
      <BannerSection />
      {isLocalhost() && <ApiUrlSection />}
    </KitAppSettings>
  );
}
